import { Middleware } from '@reduxjs/toolkit';

import { ACTION_NAMES, ACTION_STATE } from './../constants/index';
import { delay } from '../utils';
import { resetAuth } from './auth/authSlice';
import { ERROR_TYPES, PAGES } from '../utils/constantTypes';
import { ACTIONS, SLICES } from '../constants';

const apiMiddleware: Middleware =
  ({ dispatch }) =>
  (next) =>
  async (action) => {
    if (
      action?.type !==
        ACTIONS[SLICES.AUTH][ACTION_NAMES.LOGIN][ACTION_STATE.REJECTED] &&
      (action?.payload?.msg === ERROR_TYPES.UNAUTHORIZED ||
        action?.payload?.message === ERROR_TYPES.UNAUTHORIZED ||
        action?.payload?.statusCode === 401 ||
        // // since statusCode was changed to 400 due to mobile app issue
        (action?.payload?.statusCode === 400 &&
          action?.payload.message === 'Something wrong with the token') ||
        // // check for invoices related apis
        action?.payload === ERROR_TYPES.INVALID_SESSION)
    ) {
      dispatch(resetAuth());
      localStorage.clear();
      await delay(2000);
      window.location.href = PAGES.LOGIN;
    }
    return next(action);
  };

export default apiMiddleware;
